
// @ts-ignore
    import __i18nConfig from '@next-translate-root/i18n'
// @ts-ignore
    import __loadNamespaces from 'next-translate/loadNamespaces'
// @ts-ignore
    
import React from "react";
import useTranslation from "next-translate/useTranslation";
import Trans from "next-translate/Trans";

import { Head } from "@/components/Head";
import { useTheme } from "@/hooks/useTheme";
import { Converter } from "@/containers/Converter";

import { MagicianSection } from "@/sections/MagicianSection";
import { TrustedBySection } from "@/sections/TrustedBySection";
import { SelectFormatSection } from "@/sections/SelectFormatSection";
import { ApiTeaserSection } from "@/sections/ApiTeaserSection";
import { CTASection } from "@/sections/CTASection";
import { ShareDesignSection } from "@/sections/ShareDesignSection";
import { PricingSection } from "@/sections/PricingSection";
import { ConversionSection } from "@/sections/ConversionSection";

const FigjamToMiro = () => {
  const { t } = useTranslation();
  const { colors } = useTheme();
  return (
    <>
      <Head
        pageNamespace="page/FigjamToMiro"
        ogImage="/images/figjam2miro-og-image.jpg"
      />

      <MagicianSection
        title={t("page/FigjamToMiro:title")}
        subtitle={t("page/FigjamToMiro:subtitle")}
        magicianLogoFile="miro"
        showStartsAt={false}
      >
        <Converter />
      </MagicianSection>

      <TrustedBySection />

      <ApiTeaserSection
        title={
          ((
            <Trans
              i18nKey="page/FigjamToMiro:section/apiTeaser.title"
              components={[<span style={{ color: colors.ORANGE }} key={0} />]}
            />
          ) as unknown) as string
        }
        backgroundColor="#fffffe"
        cta={{
          title: t("common:actions.doNow", { do: t("common:actions.convert") }),
        }}
        elements={t(
          "page/FigjamToMiro:section/apiTeaser.apiTeaserElements",
          null,
          {
            returnObjects: true,
          },
        )}
        image={{
          src: "/images/figjam-to-miro-example.png",
          alt: "Miro to Figjam Example",
        }}
      />

      <ShareDesignSection
        id="ShareDesignSection"
        title={
          ((
            <Trans
              i18nKey="page/FigjamToMiro:section/shareDesign.title"
              components={[<span key="0" style={{ color: colors.ORANGE }} />]}
            />
          ) as unknown) as string
        }
        image={{
          src: "/images/figjam-to-miro-converted-file-elements.jpg",
          alt: t("page/FigjamToMiro:section/shareDesign.imageAlt"),
        }}
        backgroundColor={colors.LIGHT_GRAY1}
        cta={{
          title: t("page/FigjamToMiro:section/shareDesign.ctaButton"),
        }}
        elements={[
          {
            id: "ELEMENT#1",
            iconType: "NOTES",
            title: t(
              "page/FigjamToMiro:section/shareDesign.elements.pathElementsTitle",
            ),
            text: t(
              "page/FigjamToMiro:section/shareDesign.elements.pathElementsText",
            ),
          },
          {
            id: "ELEMENT#2",
            iconType: "CHECK-CIRCLED-EMPTY",
            title: t(
              "page/FigjamToMiro:section/shareDesign.elements.folderStructureTitle",
            ),
            text: t(
              "page/FigjamToMiro:section/shareDesign.elements.folderStructureText",
            ),
          },
        ]}
        customStyle={{
          color: "green",
          nested: {
            "& li:nth-child(2) path": {
              fill: colors.GRADIENT_BLUE_DARK,
            },
          },
        }}
      />

      <PricingSection />
      <ConversionSection
        title={t("page/FigjamToMiro:section/conversion.title")}
        iconBadges={[
          {
            iconType: "SHEETS",
            text: t("page/FigjamToMiro:section/conversion.badges.supportsAll"),
          },
          {
            iconType: "NOTES",
            text: t("page/FigjamToMiro:section/conversion.badges.stickyNotes"),
          },
          {
            iconType: "ARROW-BLACK",
            text: t("page/FigjamToMiro:section/conversion.badges.connectors"),
          },
        ]}
        elements={{
          from: {
            iconType: "FIGJAM",
            image: "/images/figjam-illustrator-preview.jpg",
            title: "Figjam Import Demo Preview",
          },
          to: {
            iconType: "MIRO",
            image: "/images/miro-illustrator-preview.jpg",
            title: "Illustrator Demo Preview",
          },
        }}
      />

      <SelectFormatSection title={t("section/selectFormat:title")} />

      <CTASection
        title={t("section/cta:titles.figjamToMiroPage")}
        href="#upload"
      />
    </>
  );
};

// Temporal workaround for https://github.com/vercel/next.js/discussions/18396
 async function _getStaticProps() {
  return {
    props: {},
  };
}

export default FigjamToMiro;


// @ts-ignore
    export async function getStaticProps(ctx) {
// @ts-ignore
        let res = _getStaticProps(ctx)
// @ts-ignore
        if(typeof res.then === 'function') res = await res
// @ts-ignore
        return {
// @ts-ignore
          
// @ts-ignore
          ...res,
// @ts-ignore
          props: {
// @ts-ignore
            ...(res.props || {}),
// @ts-ignore
            ...(await __loadNamespaces({
// @ts-ignore
              ...ctx,
// @ts-ignore
              pathname: '/converter/figjam-to-miro',
// @ts-ignore
              loaderName: 'getStaticProps',
// @ts-ignore
              ...__i18nConfig,
// @ts-ignore
              
// @ts-ignore
            }))
// @ts-ignore
          }
// @ts-ignore
        }
// @ts-ignore
    }
// @ts-ignore
  